import { Component, h, type ComponentChildren, type VNode } from "preact";

interface Props {
  fallback: VNode;
  onError: (error: Error) => void;
  children?: ComponentChildren;
}

interface State {
  errored: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { errored: false };

  override componentDidCatch(error: Error): void {
    this.props.onError(error);
    this.setState({ errored: true });
  }

  override render(): VNode | ComponentChildren {
    if (this.state.errored) return this.props.fallback;
    return this.props.children;
  }
}

export const defaultFallback = (): VNode =>
  h(
    "div",
    {
      role: "alert",
      style:
        "padding:1rem;border:1px solid #fca5a5;background:#fef2f2;color:#7f1d1d;font-family:system-ui,sans-serif;font-size:0.875rem;border-radius:0.375rem",
    },
    "Widget konnte nicht geladen werden.",
  );
